import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { siteWide } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import ButtonStyles from '@stories/Components/Button/Button.styles';
import styled from 'styled-components';
import ColourPickerStyles from './ColourPicker/ColourPicker.styles';
const Container = styled.section ``;
const Inner = styled.div `
  ${siteWide};

  @media ${until(Device.MobileLarge)} {
    &[data-mobile-stretch='true'] {
      padding: 0;
    }
  }

  &[data-no-colours='false'][data-no-options='true'] {
    display: grid;

    @media ${from(Device.TabletLarge)} {
      ${() => BottomWrapper},
      ${ColourPickerStyles.Container} {
        grid-area: 1 / 1 / 2 / 2;
      }
    }
  }
`;
const Beneath = styled.div `
  background-color: ${brand.beige};
  padding: 30px 0 ${fluid(32, 80)};

  @media ${from(Device.MobileLarge)} {
    padding-top: 120px;
    margin-top: -130px;
  }
`;
const BottomWrapper = styled.div `
  display: grid;
  gap: 28px;
  padding-top: ${fluid(26, 46)};

  @media ${from(Device.TabletSmall)} {
    grid-template-columns: 1fr 1fr;
  }

  @media ${from(Device.Desktop)} {
    grid-template-columns: 3fr 1fr;
  }
`;
const ListWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1128px;

  @media ${from(Device.Desktop)} {
    flex-direction: row;
  }
`;
const LinkWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${fluid(16, 24)};

  ${ButtonStyles.Container} {
    width: 100%;
  }

  ${ButtonStyles.Text} {
    margin: 0 auto;
    text-align: center;
  }

  @media ${until(Device.Tablet)} {
    align-items: center;
  }
`;
const RangeDetailGalleryStyles = {
    Container,
    Inner,
    Beneath,
    ListWrapper,
    BottomWrapper,
    LinkWrapper,
};
export default RangeDetailGalleryStyles;
